import React, { Component } from 'react';
import './product-details.scss';
import { connect } from 'react-redux';
import { getDatabaseAction } from '../../redux/actions/actions';
import { saveCart } from '../util/localStorage';
import AddedToCartMessage from '../util/AddedToCartMessage';
import { TiArrowBack } from 'react-icons/ti';
import RelatedProducts from './RelatedProducts';
import { storage } from '../../app-firebase/firebase';
import PropTypes from 'prop-types'
import ReactLoading from 'react-loading';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import noImageAvailable from '../../images/products/no_image_book.jpg';

/**
 * ProductDetails Component
 * Contains detailed information about the product chosen by the user. It
 * provides an "Add to cart" button so the user can create a list of products
 * to buy more than one product at the checkout.
 */
class ProductDetails extends Component {

   constructor(props) {
      super(props);

      this.state = {
         itemAdded: false,
         image: '',
         done: false,
         screenWidth: window.screen.width
      }
   }

   componentDidMount() {
      if (!this.props.stock) {
         this.getDb().then(() => {
            if (this.props.image.length) {
               storage.ref().child(this.props.image[0]).getDownloadURL().then(url => {
                  this.setState({
                     image: url
                  });
               });
            }
         });
      } else {
         if (!this.state.image) {
            this.setState({
               image: noImageAvailable
            });
         }
      }
   }

   componentDidUpdate() {
      if (!this.props.stock) {
         if (this.props.image.length) { 
            storage.ref().child(this.props.image[0]).getDownloadURL().then(url => {
               if (this.state.image !== url) {
                  this.setState({
                     image: url
                  });
               }
            });
         }
      } else {
         if (!this.state.image) {
            this.setState({
               image: noImageAvailable
            });
         }
      }
   }

   componentWillUnmount() {
      this.setState({ 
         image: '',
         itemAdded: false
      })
   }

   async getDb() {
      await this.props.dispatch(getDatabaseAction());
   }

   
   /**
    * Event handler.
    * It will handle the click event whenever the user clicks on the "Add to cart"
    * button.
    * 
    * @param {Event object} e 
    * @param {any} id 
    */
   handleAddToCart(e) {
      e.preventDefault();
      saveCart(this.props.product);
      this.props.updateCartStorage();
      
      if (!this.state.itemAdded) {
         this.setState({
            itemAdded: true
         });
      }
   }


   getPricesDiv() {
      if (this.props.priceCad === this.props.priceUsd) {
         return (
            <div className="pd-pri">
               <p>Retail price:</p>
               <div className="pd-prices d-flex justify-content-between">
                  {this.props.priceCad && this.props.priceUsd ? <p className="pd-price">USD$/CAD$ {this.props.priceCad.toFixed(2)}</p> : null}
               </div>
            </div>
         )
      }
      else {
         return (
            <div className="pd-pri">
               <p>Retail price:</p>
               <div className="pd-prices d-flex justify-content-between">
                  {this.props.priceUsd ? <p className="pd-price">USD$ {this.props.priceUsd.toFixed(2)}</p> : null}
                  {this.props.priceCad ? <p className="pd-price">CAD$ {this.props.priceCad.toFixed(2)}</p> : null}
               </div>
            </div>
         )
      }
   }


   render() {
      const description = this.props.description ? this.props.description.map((p, index) => {
         return <p key={index}>{p}</p>
      }) : null;

      const keywords = `${this.props.type}, ${this.props.title}, ${this.props.subject}, ${Array.isArray(this.props.category) ? this.props.category.join(' ,') : this.props.category}, ${this.props.author}, reformed book, reformed book fo children, CDs, DVDs, sheet music`;
      return (
      <div>
         <Helmet>
            <title>{this.props.title}</title>
            <meta name="keywords" content={keywords}/>
         </Helmet>
         <main className="pd-main">
            <div className="pd-linear-bg"></div>
            {this.props.lastProductPage ?
               <Link to={'/products/'} className="back-link"><span><TiArrowBack/></span> Products</Link> :
               null   
            }
            <div className="pd-img d-flex flex-column justify-content-start">
               {
                  this.state.image ?
                     <img src={this.state.image} alt={this.props.title} style={{width:'15rem'}}/> :
                     <ReactLoading type={"spokes"} color={"black"} />
               }
               {
                     <div className="pd-sir">
                     <p>ISBN: {this.props.isbn}</p>
                     {this.props.number ? <p>{this.props.number}</p> : null}
                     {this.props.subject ? <p>Subject: {this.props.subject}</p> : null}

                     {this.props.totalTime ? <p>Total Time: {this.props.totalTime}</p> : null}

                     {this.getPricesDiv()}
                     
                     <div className="pd-atc f-flex flex-column">

                        {this.state.image ?
                           <button className="btn btn-success btn-block" onClick={(e) => this.handleAddToCart(e)}>
                              Add to cart
                           </button> :
                           <button disabled className="btn btn-success btn-block" onClick={(e) => this.handleAddToCart(e)}>
                              Add to cart
                           </button>
                        }

                        <AddedToCartMessage wasAdded={this.state.itemAdded} />

                        {/* {this.state.itemAdded ?
                           <div className="pd-atc-confirm text-center">
                              <span><AiOutlineCheck/> &nbsp;&nbsp;&nbsp;&nbsp; Added to Cart</span>
                           </div> :
                           null
                        } */}
                     </div>
                  </div>
               }
            </div>
            <section className="pd-info">
               <div className="pd-titles">
                  <h1>{this.props.title}</h1>
                  {this.props.subtitle ? <h3>{this.props.subtitle}</h3> : null}
                  {this.props.author ? <p>By {this.props.author}</p> : null}
               </div>
               
               <div style={{borderLeft: '.2rem solid #00A908', paddingLeft: '.5rem'}}>
                  {description}
               </div>
               
               <div style={{borderLeft: '.2rem solid #890022', paddingLeft: '.5rem'}}>
                  {
                     Array.isArray(this.props.category) ?
                     this.props.category.map((cat, index) => {
                        return <p key={index} style={{fontWeight: 'bold'}}>{cat}</p>
                     }) :
                     <p style={{fontWeight: 'bold'}}>{this.props.category}</p>
                  }
               </div>
            </section>
         </main>

         <div className="pd-desc">
            <div className="pd-desc-text">
               {/* <div className="">
                  <p>ISBN: {this.props.isbn}</p>
                  {this.props.number ? <p>{this.props.number}</p> : null}
                  {this.props.subject ? <p>Subject: {this.props.subject}</p> : null}

                  {this.props.totalTime ? <p>Total Time: {this.props.totalTime}</p> : null}

                  {this.getPricesDiv()}
                  
                  <div className="pd-atc f-flex flex-column">

                      {this.state.image ?
                        <button className="btn btn-success btn-block" onClick={(e) => this.handleAddToCart(e)}>
                           Add to cart
                        </button> :
                        <button disabled className="btn btn-success btn-block" onClick={(e) => this.handleAddToCart(e)}>
                           Add to cart
                        </button>
                      }

                     {this.state.itemAdded ?
                        <div className="pd-atc-confirm text-center">
                           <span><AiOutlineCheck/> &nbsp;&nbsp;&nbsp;&nbsp; Added to Cart</span>
                        </div> :
                        null
                     }
                  </div>
               </div> */}
            </div>
            {/* {this.state.image.length > 1 ?
               <div className="col-12 col-md-3 d-flex flex-column">
                  {
                     this.state.image.map((img, index) => {
                        if (index === 0) return null
                        return <div style={{marginBottom: '1rem'}}><img src={img} alt={this.props.image[index]}/></div>
                     })
                  }
               </div> :
               null
            } */}
         </div>

         
         
         
         <RelatedProducts list={this.props.list} category={this.props.category} ipNumber={this.props.ipNumber}/>
         {this.props.lastProductPage ?
               <Link to={'/products'} className="back-link-bottom"><TiArrowBack/> Products</Link> :
               null   
            }
      </div>
      )
   }
}
/**
 * Establishes the component state from the redux store whenever the store
 * is updated.
 * 
 * @param {object} state The Redux global state
 */
const mapStateToProps = (state, ownProps) => {
   const books = Object.values(state.books);
   books.forEach(val => {
      if (typeof val.priceCad !== 'number') val.priceCad = Number(val.priceCad);
      if (typeof val.priceUsd !== 'number') val.priceUsd = Number(val.priceUsd);
   });
   let prod;
   for (prod of books) {
      if (ownProps.match.params.ipNumber === prod.ipNumber) {
            return {
            list: books,
            author: prod.author,
            description: prod.description,
            category: prod.category,
            image: prod.image,
            ipNumber: prod.ipNumber,
            isbn: prod.isbn,
            priceCad: Number(prod.priceCad),
            priceUsd: Number(prod.priceUsd),
            subject: prod.subject,
            subtitle: prod.subtitle,
            title: prod.title,
            type: prod.type,
            stock: prod.stock,
            product: prod
         }
      }
   }

   let allOthers = [];
   const otherProducts = Object.values(state.otherProducts);
   otherProducts.forEach(cat => allOthers = [...allOthers, ...Object.values(cat)])
   let others;
   for (others of allOthers) {
      if (ownProps.match.params.ipNumber === others.ipNumber) {
            return {
            list: books,
            author: others.author,
            description: others.description,
            category: others.category,
            image: others.image,
            ipNumber: others.ipNumber,
            isbn: others.isbn,
            priceCad: Number(others.priceCad),
            priceUsd: Number(others.priceUsd),
            subject: others.subject,
            subtitle: others.subtitle,
            title: others.title,
            type: others.type,
            stock: others.stock,
            product: others
         }
      }
   }
   
   return {
      list: [],
      author: '',
      description: [],
      category: [],
      image: [],
      ipNumber: '',
      isbn: '',
      priceCad: 0,
      priceUsd: 0,
      subject: '',
      subtitle: '',
      title: '',
      type: '',
      stock: null,
      product: null
   }
}

ProductDetails.propTypes = {
   list: PropTypes.array,
   author: PropTypes.string,
   description: PropTypes.array,
   category: PropTypes.array,
   image: PropTypes.array,
   ipNumber: PropTypes.string,
   isbn: PropTypes.string,
   priceCad: PropTypes.number,
   priceUsd: PropTypes.number,
   subject: PropTypes.string,
   subtitle: PropTypes.string,
   title: PropTypes.string,
   type: PropTypes.string,
   performers: PropTypes.object,
   conductor: PropTypes.string,
   number: PropTypes.string,
   totalTime: PropTypes.string,
   tracks: PropTypes.object,
   product: PropTypes.object,
   
}

export default connect(mapStateToProps)(ProductDetails);